let lenis = null;

export const setLenis = (instance) => {
    lenis = instance;
};

export const scrollToId = (id) => {
    const el = document.querySelector(id);
    if (!el) return;
    if (lenis) {
        lenis.scrollTo(el, { offset: -68, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
